import { clientEnv } from '@/config/env/client';
import { ReservationDeviceOrigin } from '@/types-aggregatore';
import { StateCreator } from 'zustand';
import { persistReservationChannelToSession, readReservationChannelFromSession } from '@/store/reservationChannelSession';

interface CommonStoreHandlers {
  updateHealthcareService: (value: string) => void;
  updateLocation: (value: string) => void;
  updateChannel: (value: ReservationDeviceOrigin) => void;
  updateHeaderVersion: (value: 'old' | undefined) => void;
}

interface CommonFields {
  searchForm: {
    healthcareService: string | null;
    location: string | null;
  };
  channel: ReservationDeviceOrigin;
  headerVersion: 'old' | undefined;
}

export interface CommonState extends CommonStoreHandlers, CommonFields {}

const getDefaultReservationChannel = (): ReservationDeviceOrigin => {
  if (typeof window === 'undefined') {
    return ReservationDeviceOrigin.Web;
  }

  try {
    const siteHostname = new URL(clientEnv.NEXT_PUBLIC_SITE_URL).hostname;
    return window.location.hostname === siteHostname ? ReservationDeviceOrigin.Web : ReservationDeviceOrigin.CallCenter;
  } catch {
    return ReservationDeviceOrigin.Web;
  }
};

export const createCommonSlice: StateCreator<CommonState, [], [], CommonState> = set => ({
  searchForm: {
    healthcareService: null,
    location: null,
  },
  headerVersion: undefined,
  channel: readReservationChannelFromSession() ?? getDefaultReservationChannel(),
  updateHealthcareService: (value: string): void =>
    set(state => {
      return {
        searchForm: {
          ...state.searchForm,
          healthcareService: value,
        },
      };
    }),
  updateHeaderVersion: (value: 'old' | undefined): void => set({ headerVersion: value }),
  updateLocation: (value: string): void =>
    set(state => {
      return {
        searchForm: {
          ...state.searchForm,
          location: value,
        },
      };
    }),
  updateChannel: (value: ReservationDeviceOrigin): void => {
    set({ channel: value });
    persistReservationChannelToSession(value);
  },
});
